
<template>
  <div class="mb-md abnormal">
    <el-card class="mt-md mb-md" shadow="never">
      <el-row :gutter="20">
        <el-col v-for="(item,index) in statList" :key="index" :span="24/statList.length">
          <div class="bg-light radius5" @click="select(item.code)" :class="query.code == item.code && 'active'">
            <div class="pt pl pb pr flex justify-content-space-between align-items-center">
              <div class="flex align-items-center">
                <div style="font-size: 20px">
                  <span class="iconfont icon-circle-warning text-danger mr"></span>
                </div>
                <span>{{ item.title }}</span>
              </div>
              <div style="font-size: 20px">{{ item.count }}</div>
            </div>
          </div>
        </el-col>
      </el-row>
    </el-card>
    <el-card v-loading="loading" shadow="never">
      <el-table ref="listTable" :data="list" tooltip-effect="dark">
        <el-table-column width="60" type="index" label="#" />
        <el-table-column label="接入点编号" :show-overflow-tooltip="true" min-width="120">
          <template slot-scope="scope">
            <el-link :underline="false" @click="toApDialog(scope.row)">{{ scope.row.simid }}</el-link>
          </template>
        </el-table-column>

        <el-table-column
          label="状态/通讯时间"
          min-width="120">
          <template slot-scope="scope">
            <div class="flex align-items-center">
              <div class="hd mr-sm font-lg">
                <i v-if="scope.row.is_online === 1" class="iconfont icon-circle-outline text-success"></i>
                <i v-else class="text-muted iconfont icon-circle-fill" />
              </div>
              <div class="bd" style="line-height: 16px">
                <div>{{ scope.row.is_online ? '在线' : '离线' }}</div>
                <div class="font-sm text-muted">{{ scope.row.last_upload_time * 1000 | parseTime('{y}/{m}/{d} {h}:{i}') }}</div>
              </div>
            </div>
          </template>
        </el-table-column>
        <el-table-column label="绑定设备" min-width="120">
          <template slot-scope="scope">
            <f-equip-name class="font-md" :equip="scope.row"/>  
          </template>
        </el-table-column>
        <el-table-column label="异常描述" min-width="280">
          <template slot-scope="scope">{{ scope.row.message }}</template>
        </el-table-column>
        <el-table-column label="操作" width="120">
          <template slot-scope="scope">
            <el-button type="text" @click="view(scope.row.equipid)">查看</el-button>
          </template>
        </el-table-column>
        <div slot="empty" class="flex-center column pb-md">
          <div class="flex-center mt-hg">
            <img src="../../assets/no-data.png" alt class="no-data" />
          </div>
        </div>
      </el-table>
    </el-card>
    <div class="foot" :class="!collapse && 'uncollapse'">
      <f-table-footer>
        <template slot="right">
          <f-pagination :total="total" :pindex.sync="query.pindex" :psize.sync="query.psize" @change="fetchData" />
        </template>
      </f-table-footer>
    </div>
  </div>
</template>
  
  <script>
import { apDtusimStatApi, apAbnormalApi } from "@/api/ap/apApi";

export default {
  data() {
    return {
      loading: false,

      query: {
        pindex: 1,
        psize: this.$store.state.commonStore.psize,
        code: "parser_abnormal",
      },
      list: [],
      statList: [],
      total: 0,
    };
  },
  computed: {
    collapse() {
      return this.$store.state.commonStore.collapse;
    },
  },
  created() {
    this.fetchData(1);
  },
  methods: {
    fetchData(page) {
      if (page) this.query.pindex = page
      this.loading = true;
      apAbnormalApi(this.query).then((res) => {
        this.loading = false;
        if (!res.errno) {
          this.list = res.data.list;
          this.total = res.data.total;
          this.fetchStat();
        } else {
          this.$message.error(res.message)
        }
      });
    },

    fetchStat() {
      apDtusimStatApi().then((res) => {
        if (!res.errno) {
          this.statList = res.data.list;
        } else {
          this.$message.error(res.message)
        }
      });
    },

    select(code) {
      this.query.code = code;
      this.fetchData(1);
    },
    view(equipid) {
        this.$detail({type:'equip',id:equipid})
    },
    toApDialog(row) {
      this.$detail({type:'ap',id:row.simid})
    },
  },
};
</script>
  

<style lang="scss" scoped>
.abnormal {
  .bg-light:hover {
    cursor: pointer;
  }
  .active {
    background-color: #e5f9ef;
  }
}
.foot {
  position: fixed;
  background-color: #fff;
  bottom: 0;
  left: 240px;
  width: calc(100% - 240px);

  &.uncollapse {
    left: 340px;
    width: calc(100% - 340px);
  }
}
</style>